<template>
  <b-form v-on:submit.prevent="submit()" validated novalidate>
    <b-card>
      <div slot="header">
        {{title}}
      </div>
      <b-card-body>
        <b-form-group label-for="Name" label="Name">
          <b-form-input type="text" v-model="form.name" class="form-control-warning" id="Name" required></b-form-input>
          <b-form-valid-feedback>
            Valid name provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Enter branch name.
          </b-form-invalid-feedback>
        </b-form-group>
        <Allocation :adForm="form" :hideCompany="hideCompany" :hideRegion="true" :isEdit="isEdit"></Allocation>
        <b-form-group label-for="LandingPage" label="Landing Page">
          <b-form-select id="LandingPage"
                :options="landingPages"
                v-model="form.landingPage" required>
          </b-form-select>              
          <b-form-valid-feedback>
            Valid landing page provided.
          </b-form-valid-feedback>
          <b-form-invalid-feedback>
            Select landing page.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="submit" size="sm" variant="primary" class="mr-2"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
        <router-link class="btn btn-success btn-sm" :to="{ path: '/admin/regions/list' }"><i class="fa fa-ban"></i> Cancel</router-link>
      </div>
    </b-card>
  </b-form>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import filter from './../../../mixins/filter'
import Allocation from '@/views/admin/Allocation'

export default {
  name: 'formregion',
  components: {
    Allocation
  },
  data () {
    return {
      companies: []
    }
  },
  mixins: [filter],
  props: ['title','form','mode'],
  computed: {
    companyList: function () {
      return this.companies.map((company) => {
        return {
          text: company.name,
          value: company._id
        }
      })
    },
    isEdit: function () {
      return this.mode === 'edit'
    },
    landingPages () {
      let landingPages = _.clone(this.$store.state.landingPages);
      landingPages.push({
        text: 'Inherit from company',
        value: 'inherit-from-company'
      });
      return landingPages;
    }
  },
  methods: {
    submit: function () {

      let scope = this; 

      if(!scope.form.name) {
        console.log('invalid')
        return
      }
      
      if(!scope.form.company) {
        console.log('invalid')
        return
      }

      if(!scope.form.landingPage) {
        console.log('invalid')
        return
      }

      this.$emit('submit', scope.form);
    }
  },
  created () {
    let scope = this;
    axios.get(process.env.VUE_APP_API + '/company', {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.companies = response.data;
          scope.form.company = scope.currentUser.company;
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
</script>
